import { Field, Formik, Form } from "formik";
import * as yup from "yup";
import * as emailjs from "emailjs-com";

// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";

const validationSchema = yup.object().shape({
  name: yup.string().required("*Required"),
  subject: yup.string().required("*Required"),
  message: yup.string().required("*Required"),
  email: yup.string().email("Invalid email").required("*Required"),
});



function SendEmail(object) {
  emailjs
    .send(
      "service_uxwou15",
      "template_17x2ffm",
      object,
      "thqm_dV9Pzk6FmDvL"
    )
    .then(
      (result) => {
        resetForm();
      },
      (error) => {
        alert("Oops... Something went wrong! Please try again.");
      }
    );
}

//write code to reset the form after submission
function resetForm() {
  document.getElementById("contact-form").reset();
}


//code to make a function that renders a popup once the form is submitted

function sentpopup() {
  alert("Your message has been sent!");
}

export default function Contact() {
  return (
    <div className="contact-section" id="contact">
      <div className="form">
        <div className="contact-header">
          CONTACT <b>US</b>
        </div>
        <Formik
          initialValues={{
            name: "",
            subject: "",
            email: "",
            message: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              SendEmail(values);
              actions.setSubmitting(false);
             }, 10);
          }}
        >
          {({ errors, touched, values }) => {
            return (
              <Form id="contact-form">
                <div
                  className={`input-container error-${
                    errors.name && touched.name ? "shown" : "hidden"
                  }`}
                >
                  <Field name="name" type="text" />
                  {errors.name && touched.name ? (
                    <div className="error">{errors.name}</div>
                  ) : null}
                  <label className={values.name && "filled"}>NAME*</label>
                </div>

                <div
                  className={`input-container error-${
                    errors.email && touched.email ? "shown" : "hidden"
                  }`}
                >
                  <Field type="email" name="email" />
                  {errors.email && touched.email ? (
                    <div className="error">{errors.email}</div>
                  ) : null}
                  <label className={values.email && "filled"}>EMAIL</label>
                </div>

                <div
                  className={`input-container error-${
                    errors.subject && touched.subject ? "shown" : "hidden"
                  }`}
                >
                  <Field type="text" name="subject" />
                  {errors.subject && touched.subject ? (
                    <div className="error">{errors.subject}</div>
                  ) : null}
                  <label className={values.subject && "filled"}>SUBJECT</label>
                  {errors.subject && touched.subject}
                </div>

                <div
                  name="message"
                  className={`input-container error-${
                    errors.message && touched.message ? "shown" : "hidden"
                  }`}
                >
                  <Field type="text" as="textarea" name="message" />
                  {errors.message && touched.message ? (
                    <div className="message-error">{errors.message}</div>
                  ) : null}
                  <label className={values.message && "filled"}>MESSAGE</label>
                </div>
                <button
                  style={{ cursor: "pointer" }}
                  className="btn btn-dark mt-3 submit"
                  type="submit"
                  onClick={sentpopup}
                >
                  Submit
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}
